export enum C2cCategoryPackageTypeEnum {
  Parcel = 'PARCEL',
  Document = 'DOCUMENT',
}
